import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Box } from '@mui/material'
import { Item } from '../../common/snippets'
import { BookingDeliveryDetailsUpdate, updateModal } from '../../../store/common/common_action'
import { updatePriceSectData } from '../../../store/booking/booking_action'
import { navigation1, focusElemnt } from '../../common/helper'
import { getCargoSettingFilterData } from '../../../store/reports/reports_action'
import { PARENT_COMPANY_MODE } from '../../common/constants'
import CollCartageUI from '../../../components/content/BookingActivity/CollCartageUI'
import Button from '@mui/material/Button'
import LineInputV2 from '../../common/lineinputV2'
import LineInput from '../../common/lineinput'
import { bookingGST, chargeFields } from '../../common/bookingHelper'
import { CargoRoleRightsAtom, companySettingsAtom, gstConfigAtom } from '../../common/jotaiState/commonStateAtoms'
import { companyTaxAtom } from '../../common/jotaiState/bookingStateAtoms'
import { useAtom } from 'jotai'
import useToken from '../../helpers/useTokens'
import { safeNumber } from '../../common/mathHelper'
const BookingDeliveryTab = (props) => {
  const { loginData } = useToken()
  const [gstConfig] = useAtom(gstConfigAtom)
  const [cmpnyTax] = useAtom(companyTaxAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const { data, updateModal, updatePriceSectData, BookingDeliveryDetailsUpdate, getCargoSettingFilterData } = { ...props }
  const { common, booking: bookingL, reports } = data
  const { cargoSettingFilterData } = reports
  let { priceSectionData } = { ...bookingL }
  const { citywiseBranchList, parentCompnayData } = common
  const OwnparentCompnayData = parentCompnayData.length ? parentCompnayData[PARENT_COMPANY_MODE] : {}
  const { ParentCompanyID } = OwnparentCompnayData

  const priceSection = [
    { label: 'Total Freight', type: 'text', id: 'freight', width: '9.3%', readOnly: true, value: props?.selectLr?.Freight },
    { label: 'Pickup Cartage', type: 'text', id: 'CCBrkup_pckp', width: '9.3%', value: props?.selectLr?.PickupCartage },
    { label: 'Misc. Cartage', type: 'text', id: 'CCBrkup_cmsn', width: '9.3%', value: props?.selectLr?.CommCartage },
    { label: 'Drop Cartage', type: 'text', id: 'del_cartage', width: '9.3%', value: props?.selectLr?.CartageDeliveryAmount },
    { label: 'Hamali', type: 'text', id: 'hamali', width: '9.3%', value: props?.selectLr?.HamaliCharges },
    { label: 'Op Hamali', type: 'text', id: 'op_hamali', width: '9.3%', value: props?.selectLr?.OtherCharge },
    { label: 'Valuation', type: 'text', id: 'valuation', width: '9.3%', value: props?.selectLr?.Insurance },
    { label: 'Doc Fee', type: 'text', id: 'doc_fee', width: '9.3%', value: props?.selectLr?.DocumentCharges },
    { label: 'Pickup Fee', type: 'text', id: 'pickup_fee', width: '9.3%', value: props?.selectLr?.CollectionCharges },
    { label: 'Dropoff Fee', type: 'text', id: 'dropoff_fee', width: '9.3%', value: props?.selectLr?.HomeDeliveryChg },
    { label: 'GST', type: 'text', id: 'gst', width: '9.3%', value: props?.selectLr?.ServiceTaxAmount },
  ]
  const deliveryCharge = [
    { label: 'Extra Hamali', type: 'text', value: '', id: 'Extra_Hamali', width: '8%' },
    { label: 'Delivery Hamali', type: 'text', id: 'Del_Hamali', width: '8%', value: props?.selectLr?.DeliveryHamali },
    { label: 'Demurage', type: 'text', id: 'Demurage', width: '8%', value: props?.selectLr?.DemurrageChg },
    { label: 'Drop Cartage', type: 'text', id: 'Del_Cartage', width: '8%', value: '' },
    { label: 'Delivery GST', type: 'text', id: 'Delivery_GST', width: '8%', value: '' },
  ]
  const [selectLr, setSelectLr] = useState(props?.selectLr)
  const [lrStatus, setLrStatus] = useState()
  const [discountBtn, setDiscountBtn] = useState()
  const [allowDeliveryDisc, setAllowDeliveryDisc] = useState()
  const [discount, setDiscount] = useState(0)
  const [finalAmt, setFinalAmount] = useState(0)
  const [priceSecList, setPriceSecList] = useState([...priceSection])
  const [deliveryList, setDeliveryList] = useState([...deliveryCharge])
  const [totalOutStanding, setTotalOutStanding] = useState(props?.selectLr?.NetAmount)
  const [newDemurage, setNewDemurage] = useState(props?.selectLr.DemurrageChg)
  const [isEdit, setIsEdit] = useState(false)
  const [collCartageModal, setCollCartageModal] = useState(false)
  const [additionalChrg, setAdditionalChrg] = useState('')
  useEffect(() => {
    if (loginData) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  useEffect(() => {
    const taxableFreight = chargeFields.reduce((acc, field) => {
      acc += safeNumber(priceSectionData[field])
      return acc
    }, 0)
    const [taxgst, totalAmount] = bookingGST(
      gstConfig,
      priceSectionData,
      taxableFreight,
      cmpnyTax,
      companySettings?.FreightCartageOptHamali
    )
    if (isEdit) {
      updatePriceSectData('gst', taxgst)
      updatePriceSectData('GSTAmount', cf(totalAmount))
      updatePriceSectData('gross_amount', cf(taxableFreight) + (cf(taxgst) || 0))
    }
  }, [
    priceSectionData.freight,
    priceSectionData.coll_cartage,
    priceSectionData.del_cartage,
    priceSectionData.hamali,
    priceSectionData.op_hamali,
    priceSectionData.valuation,
    priceSectionData.pickup_fee,
    priceSectionData.dropoff_fee,
    priceSectionData.doc_fee,
  ])
  const collCartageRef = useRef(null)
  useEffect(() => {
    updatePriceSectData('freight', props?.selectLr?.Freight)
    updatePriceSectData('coll_cartage', props?.selectLr?.CartageAmount)
    updatePriceSectData('del_cartage', props?.selectLr?.CartageDeliveryAmount)
    updatePriceSectData('hamali', props?.selectLr?.HamaliCharges)
    updatePriceSectData('op_hamali', props?.selectLr?.OtherCharge)
    updatePriceSectData('valuation', props?.selectLr?.Insurance)
    updatePriceSectData('doc_fee', props?.selectLr?.DocumentCharges)
    updatePriceSectData('pickup_fee', props?.selectLr?.CollectionCharges)
    updatePriceSectData('dropoff_fee', props?.selectLr?.HomeDeliveryChg)
    updatePriceSectData('gst', props?.selectLr?.ServiceTaxAmount)
    updatePriceSectData('gross_amount', props?.selectLr?.NetAmount)
    updatePriceSectData('CCBrkup_cmsn', props?.selectLr?.CommCartage)
    updatePriceSectData('CCBrkup_pckp', props?.selectLr?.PickupCartage)
    updatePriceSectData('CCBrkup_rtrn', props?.selectLr?.ReturnCartage)
    updatePriceSectData('addiTionalChrg', props?.selectLr?.ConvenienceCharge)
    setAdditionalChrg(props?.selectLr?.ConvenienceCharge)
  }, [])
  useEffect(() => {
    const { IsCartage, IsDelCartage, IsHamali, IsOperatorHamali } = companySettings || {}
    const { IsInsurance, IsDocument, IsPickUpAndDropOffChg, DisableDocChg } = companySettings || {}
    const [{ DisablePickupCartage, DisableMiscellaneousCartage, DisableBookingDeliveryCartage }] = citywiseBranchList || []
    const {
      Table1: [{ AllowHamaliEdit, AllowOperatorHamaliEdit, AllowShowAdditional }],
    } = roleRights || {}
    const updatedpriceSection = [
      priceSection[0],
      { ...priceSection[1], readOnly: AllowShowAdditional === 0 || !IsCartage || DisablePickupCartage === 1 },
      { ...priceSection[2], readOnly: AllowShowAdditional === 0 || !IsCartage || DisablePickupCartage === 1 },
      { ...priceSection[3], readOnly: AllowShowAdditional === 0 || !IsDelCartage || DisableBookingDeliveryCartage === 1 },
      { ...priceSection[4], readOnly: AllowShowAdditional === 0 || !IsHamali || !AllowHamaliEdit },
      { ...priceSection[5], readOnly: AllowShowAdditional === 0 || !IsOperatorHamali || !AllowOperatorHamaliEdit },
      { ...priceSection[6], readOnly: AllowShowAdditional === 0 || !IsInsurance },
      { ...priceSection[7], readOnly: AllowShowAdditional === 0 || !IsDocument || ParentCompanyID === 10 || DisableDocChg === 1 },
      { ...priceSection[8], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
      { ...priceSection[9], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
      { ...priceSection[10], readOnly: true },
    ]
    setPriceSecList(updatedpriceSection)
  }, [companySettings, roleRights, ParentCompanyID, citywiseBranchList])

  function cf(x) {
    //convert to float
    var floatValue = +x
    return floatValue
  }
  function getTax(Amount) {
    try {
      if (Amount >= cmpnyTax[0].MinTaxAmount && cmpnyTax[0].TaxPct > 0) {
        return Math.round((Amount * cmpnyTax[0].TaxPct) / 100)
      } else {
        return 0
      }
    } catch (e) {}
  }
  useEffect(() => {
    if (collCartageRef && collCartageRef.current && collCartageModal) {
      setTimeout(() => {
        focusElemnt(`CCBrkup_pckp`)
      }, 200)
    }
  }, [collCartageRef, collCartageModal])
  useEffect(() => {
    let pickup = Number(priceSectionData.CCBrkup_pckp) || 0
    let misc = Number(priceSectionData.CCBrkup_cmsn) || 0
    updatePriceSectData('coll_cartage', pickup + misc)
  }, [priceSectionData.CCBrkup_pckp, priceSectionData.CCBrkup_cmsn])
  const handlePriceSect = (e, key) => {
    setIsEdit(true)
    // if (key == 'coll_cartage' && companySettings?.HasCartageBreakup) return
    updatePriceSectData(key, +e.target.value)
  }
  const getPriceSectUI = (data, index, lastIndex = false) => {
    const { label, type = 'text', id, width = '9%', value, readOnly = false } = { ...data }
    const nextId = lastIndex
      ? lastIndex && selectLr?.Status === 'BRANCH RECEIVED'
        ? 'Demurage'
        : `updateBookingDelCharges`
      : priceSection[index + 1].id
    const prevId = index === 0 || index === 1 ? 'frieght' : priceSection[index - 1].id
    return (
      <div className="priceSection" key={`price_sec_${id}_${label}`} style={{ width }}>
        <div className={'input--wrapper btmSpaceNotRequired'}>
          <LineInputV2
            id={id}
            type={type}
            name={id}
            label={label}
            // value={value ? value : 0}
            autoFocus={id === 'coll_cartage' ? true : false}
            disabled={readOnly}
            value={priceSectionData[id]}
            // onFocus={(e) =>
            //   id == 'coll_cartage' && companySettings?.HasCartageBreakup ? setCollCartageModal(true) : setCollCartageModal(false)
            // }
            onBlur={(e) => {
              handlePriceSect(e, id)
            }}
            onKeyDown={(e) => navigation1(e, nextId, prevId)}
          />
        </div>
        <div className="plusSymbl">{lastIndex ? `=` : `+`}</div>
      </div>
    )
  }
  const handleDeliverySect = (e, key) => {
    const ele = deliveryList?.find((el) => {
      return el.id === e.target.id
    })
    if (ele.id === 'Demurage') {
      ele.value = e.target.value
      setNewDemurage(e.target.value)
    }
    setDeliveryList([...deliveryList])
    let deemurage = 0
    for (let i in deliveryList) {
      deemurage = parseInt(deliveryList[2].value)
    }
    let total = cf(deemurage) + cf(priceSectionData.gross_amount)
    setTotalOutStanding(total)
  }
  const getDeliverySectUI = (data, lastIndex = false, i) => {
    const { label, value, type = 'text', id, width = '8%', readOnly = false } = { ...data }
    return (
      <div
        key={`delivery_sec_${id}_${label}`}
        className={
          i === 0
            ? 'ex-hamali deliverySection priceSection'
            : 'deliverySection priceSection' && lastIndex === true
            ? 'del-gst deliverySection priceSection'
            : 'deliverySection priceSection'
        }
      >
        <div className={'input--wrapper btmSpaceNotRequired'}>
          <LineInput
            // disabled={i === 0 || i === 1 || i === 3 || i === 4 || (i === 2 && selectLr?.Status !== 'BRANCH RECEIVED')} // if status RECEIVED
            disabled={
              i === 0 ||
              i === 1 ||
              i === 3 ||
              i === 4 ||
              (i === 2 && roleRights?.Table?.filter((val) => val.BookingRightsID == 13)?.[0]?.Allowed == 0)
            } // if status RECEIVED
            key={id}
            type={type}
            name={id}
            id={id}
            label={label}
            value={value}
            onChange={(e) => handleDeliverySect(e, id)}
            // onBlur={(e) => handleDeliverySectBlur(e, id)}
            onKeyDown={(e) => navigation1(e, `updateBookingDelCharges`, `gst`)}
            //onKeyDown={(e) => delKeyPress(e, id)}
            // disabled={readOnly}
          />
        </div>
        <div className="plusSymbl">{lastIndex ? `` : `+`}</div>
      </div>
    )
  }
  const UpdateBookingDeliveryCharges = () => {
    const obj = {
      BookingID: selectLr?.BookingID,
      UserID: loginData.intUserID,
      CompanyID: loginData.intCompanyID,
      Freight: priceSectionData.freight,
      CollectionCartage: priceSectionData.coll_cartage,
      DeliveryCartage: priceSectionData.del_cartage,
      Hamali: priceSectionData.hamali,
      OptHamali: priceSectionData.op_hamali,
      Valuation: priceSectionData.valuation,
      DocumentCharge: priceSectionData.doc_fee,
      PickupCharge: priceSectionData.pickup_fee,
      DropoffCharge: priceSectionData.dropoff_fee,
      BookingGST: priceSectionData.gst,
      NetAmount: priceSectionData.gross_amount,
      InsuranceProviderID: 0,
      DemurrageOld: selectLr?.DemurrageChg,
      DemurrageNew: newDemurage,
      PickupCartage: priceSectionData.CCBrkup_pckp,
      CommCartage: priceSectionData.CCBrkup_cmsn,
      ReturnCartage: priceSectionData.CCBrkup_rtrn,
      ConvenienceCharge: additionalChrg,
      GSTAmount: priceSectionData?.GSTAmount || 0,
    }
    BookingDeliveryDetailsUpdate(obj, props.setOnClosePopup)
    updateModal()
    props.updateData() //To update data on list Screen
  }
  return (
    <>
      <div style={{ width: '100%' }}>
        <div className="booking--line--input--wrappers" style={{ display: 'flex', width: '100%' }}>
          <div style={{ width: '100%', display: 'flex', margin: '0 10px' }}>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`LR No.`} value={selectLr.LRNo} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>

            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput
                      className="input-lable"
                      type="text"
                      label={`Manul LR Number`}
                      value={selectLr.ManualLRNo ? selectLr.ManualLRNo : '-'}
                      disabled={true}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`Payment Type`} value={selectLr.PaymentType} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`Challan Number`} value={selectLr?.VoucherNo} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
          </div>
        </div>
        <div className="akash">
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              padding: '0px 26px',
              alignItems: 'center',
              marginBottom: '10px',
              boxshadow: '0 1px 3px #ddd',
              border: '1px solid gray',
              padding: '10px 11px 10px 18px',
            }}
          >
            {priceSecList?.map((data, i, { length }) => getPriceSectUI(data, i, i + 1 === length))}
            <Item sx={{ width: '8%', marginLeft: '2px', paddingTop: '13px', paddingBottom: '13px' }} className={`Del_Grs_amt`}>
              <div style={{ background: '#00ff72 !important' }}>Gross Amt</div>
              {/* <div>{grossTotal ? grossTotal : 0}</div> */}
              <div>{priceSectionData?.gross_amount?.toFixed(2)}</div>
            </Item>
          </Box>
          <Box
            className="amountCalculation"
            sx={{
              display: 'flex',
              width: '100%',
              padding: '0px 11px 0px 9px !important',
              alignItems: 'center',
              // border: '1px solid gray',
              //  borderTop: '1px solid #e6e6e6',
              marginTop: '10px',
              boxshadow: '0 1px 3px #ddd',
              borderBottom: '1px solid gray !important',
            }}
          >
            <Item sx={{ width: '14%' }}>
              <div
                style={{
                  background: '#1eb24b',
                  color: '#fff',
                  padding: '10px 32px',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  borderRadius: '3px',
                }}
              >
                Gross Amt (Due)
                <div>{selectLr?.PaymentType === 'PAID' ? 0 : priceSectionData?.gross_amount?.toFixed(2)}</div>
              </div>
            </Item>
            <div className="plusSymbl" sx={{ width: '2%' }}>
              +
            </div>
            <Item sx={{ width: '6%' }} style={{ whiteSpace: 'nowrap', marginRight: '20px' }}>
              <div style={{ color: '#000', padding: '19px 0px', fontSize: '14px' }}>Delivery Charges</div>
            </Item>

            {deliveryList.map((data, i, { length }) => {
              return getDeliverySectUI(data, i + 1 === length, i)
            })}
            <span className="plusSymbl">{`-`}</span>
            <Box sx={{ width: '7%', display: 'inline-flex', paddingLeft: ' 2px', paddingRight: '2px', marginTop: '16px' }}>
              <div className={'input--wrapper'} style={{ width: '100%' }}>
                <LineInput
                  id={`Discount`}
                  type={'text'}
                  name={'Discount'}
                  label={'Discount'}
                  value={discountBtn === 2 || discountBtn === 4 || discountBtn === 7 || allowDeliveryDisc === 1 ? discount : 0}
                  disabled={
                    (discountBtn === 2 || discountBtn === 4 || discountBtn === 7 || allowDeliveryDisc === 1) && lrStatus !== 1
                      ? false
                      : true
                  }
                />
              </div>
            </Box>
            <div className="equal plusSymbl">=</div>
            <Item
              sx={{ width: '11%', marginLeft: '10px', padding: '8px', paddingTop: '13px', paddingBottom: '13px', marginBottom: '10px' }}
              className={`Del_Grs_amt`}
            >
              <div style={{ background: '#00ff72 !important' }}>Total Out Standing</div>
              <div>
                {selectLr?.PaymentType === 'PAID'
                  ? newDemurage
                  : (cf(priceSectionData?.gross_amount?.toFixed(2)) + cf(newDemurage))?.toFixed(2)}
              </div>
            </Item>
          </Box>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right', justifyContent: 'right', marginRight: '10px' }}>
          {cargoSettingFilterData?.[0]?.IsConvCharge === 1 ? (
            <Item sx={{ width: '10%', alignItems: 'center' }} className={'input--wrapper'}>
              <LineInputV2
                label={'Conv. Chrg'}
                type="text"
                name="Conv_Chrg"
                value={additionalChrg}
                onBlur={(e) => setAdditionalChrg(e.target.value)}
              />
            </Item>
          ) : (
            ''
          )}
          <Item sx={{ background: '#fff', border: '1px solid #f15a22', textAlign: 'center', margin: '10px', height: '47px' }}>
            <Button
              variant="outlined"
              sx={{ width: '10%', height: '-webkit-fill-available' }}
              style={{ borderColor: '#fff', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
              onClick={() => updateModal()}
              //   disabled={cancelEdit == true ? true : false}
            >
              {' '}
              CANCEL
            </Button>
          </Item>
          <Item
            sx={{
              width: '10%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '0px',
              padding: '0',
              //   backgroundColor: '#f0fcf4',
            }}
          >
            <Button
              id={`updateBookingDelCharges`}
              variant="contained"
              className="btn btn-primary"
              //autoFocus={false}
              onClick={() => {
                UpdateBookingDeliveryCharges()
              }}
              sx={{
                width: '100%',
                padding: '10px',
                letterSpacing: '2px',
              }}
              //    onKeyDown={(e) => navigation1(e, '', `Demurage`)}
            >
              UPDATE
            </Button>
          </Item>
        </div>
      </div>
      {collCartageModal && <CollCartageUI inputRef={collCartageRef} setCollCartageModal={setCollCartageModal} callFromAdmin={true} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updatePriceSectData,
  BookingDeliveryDetailsUpdate,
  getCargoSettingFilterData,
}
export default connect(mapStateToProps, mapDispatchToProps)(BookingDeliveryTab)
